<template>
  <Permissioned permission="workers.view" vertical>
    <h2 class="pt-1 pb-3">
      Basic Details
    </h2>
    <LabeledText label="Email">
      {{ userData.email }}
    </LabeledText>
    <LabeledText label="Phone Number">
      {{ userData.phone }}
    </LabeledText>
    <LabeledText label="Date of Birth">
      {{ dob }}
    </LabeledText>
    <LabeledText label="Address">
      {{ address }}
    </LabeledText>
    <BooleanChip
      label="Internal Candidate"
      :value="userData.isInternalCandidate"
    />
    <BooleanChip
      label="Redeployment Candidate"
      :value="userData.isRedeploymentCandidate"
    />
  </Permissioned>
</template>

<script>
import Permissioned from "@/components/common/Permissioned";
import LabeledText from "@/components/common/BaseDetails/LabeledText";
import { formatDate } from "@/utils/time";
import { BASE_DATE_FORMAT } from "@/constants/common";
import { formatAddress } from "@/utils/users";
import BooleanChip from "@/components/common/BaseDetails/BooleanChip";

export default {
  components: {
    LabeledText,
    Permissioned,
    BooleanChip
  },
  props: {
    userData: {
      type: Object,
      required: true
    }
  },
  computed: {
    dob() {
      return formatDate({
        date: this.userData.dob,
        endFormat: BASE_DATE_FORMAT
      });
    },
    address() {
      return formatAddress(this.userData.addresses) || "-";
    }
  }
};
</script>

<style lang="scss"></style>
